import { render, staticRenderFns } from "./DeleteObject.vue?vue&type=template&id=44304d0e&scoped=true"
import script from "./DeleteObject.vue?vue&type=script&lang=js"
export * from "./DeleteObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44304d0e",
  null
  
)

export default component.exports